import React, { useState, useEffect } from "react";
import "./ManageSubscriptionPage.css";
import "../landingpage/LandingPageStyles";
import DownArrowIcon from "../../assets/images/down.svg";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Row, Col, notification, Spin, Input, Typography, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import { cancelSubscription } from "../../api/password";
import { applyCouponCode, getPublicPlans } from "../../api/Stripe.js";
import CancelPopup from "../../components/CancelPopup/CancelPopup";
import { getRequest, postRequest } from "../../api";
import { styles } from "../onboarding/PaymentMethodStyles.js";

function ManageSubscriptionPage() {
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const location = useLocation();
  const subscriptionId = location.state?.subscriptionId;
  const planName = subscriptionDetails?.planName?.planName;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const [subscriptionChanged, setSubscriptionChanged] = useState(false);
  const navigate = useNavigate();
  const [coupon, setCoupon] = useState("");
  const [isCouponApplying, setIsCouponApplying] = useState(false);

  const handleGoBackButton = () => {
    navigate("/landing-page");
  };

  const handleApplyCoupon = async () => {
    if (!coupon) return;
    setIsCouponApplying(true);

    try {
      const response = await applyCouponCode({ couponCode: coupon });
      if (response.status === 200) {
        notification.success({
          message: "Coupon Applied Successfully",
          description: response.message,
        });
      } else if (response.status === 400) {
        notification.error({
          message: "Error Applying Coupon",
          description: response.message,
        });
      } else if (response.status === 404) {
        notification.error({
          message: "Error Applying Coupon",
          description: "No active subscriptions found",
        });
      } else {
        notification.error({
          message: "Error Applying Coupon",
          description: "An unexpected error occurred. Please try again.",
        });
      }
    } catch (error) {

      console.error("Error applying coupon: ", error);

      notification.error({
        message: "Error Applying Coupon",
        description: error.message,
      });
    } finally {
      setIsCouponApplying(false);
    }
  };

  useEffect(() => {
    fetchLatestSubscription();
    fetchPlans();
  }, [subscriptionChanged]);

  const fetchPlans = async () => {
    try {
      setLoadingPlans(true);
      const response = await getPublicPlans();
      if (response && response.data && response.data.subscriptionPlans) {
        setPlans(response.data.subscriptionPlans);
      }
    } catch (error) {
      console.error('Error fetching plans:', error);
    } finally {
      setLoadingPlans(false);
    }
  };

  const fetchLatestSubscription = async () => {
    try {
      const latestSubscription = await getRequest(
        "/stripe/latest-subscription"
      );

      setSubscriptionDetails({
        status: latestSubscription.subscriptionDetails.status,
        planName: latestSubscription.subscriptionDetails,
      });
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to fetch subscription details",
        duration: 10,
      });
    }
  };

  const handleCancelSubscription = async () => {
    setIsCanceling(true);
    try {
      const response = await cancelSubscription();
      if (response.error) {
        notification.error({
          message: "Cancel Subscription Error",
          description: response.error,
          duration: 10,
        });
      } else {
        notification.success({
          message: "Subscription Canceled",
          description: "Your subscription has been canceled successfully.",
          duration: 10,
        });
        setSubscriptionChanged((prev) => !prev);
      }
    } catch (error) {
      notification.error({
        message: "Cancel Subscription Error",
        description: error.message,
        duration: 10,
      });
    } finally {
      setIsCanceling(false);
      closeCancelPopup();
    }
  };

  const openCancelPopup = () => {
    setShowCancelPopup(true);
  };
  const closeCancelPopup = () => {
    setShowCancelPopup(false);
  };
  const confirmCancelSubscription = async () => {
    await handleCancelSubscription();
    closeCancelPopup();
  };

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleUpgradeClick = () => {
    navigate("/subs2", {
      state: {
        subscriptionId: subscriptionId,
        subscriptionDetails: subscriptionDetails,
      },
    });
  };

  const monthlyPlan = plans.find(p => p.interval === 'month');
  const annualPlan = plans.find(p => p.interval === 'year');
  const monthlyPrice = monthlyPlan?.price?.toFixed(2) || '7.29';
  const annualPrice = annualPlan?.price?.toFixed(2) || '69.90';

  const renderCancelButton = () => {
    if (
      subscriptionDetails?.status !== "canceled" &&
      planName !== "Free Plan"
    ) {
      return (
        <button
          className="cancel-btn"
          onClick={openCancelPopup}
          disabled={isCanceling}
        >
          {isCanceling ? (
            <span className="flex items-center justify-center">
              <Spin size="small" className="mr-2" />
              Canceling...
            </span>
          ) : (
            "Cancel Subscription"
          )}
        </button>
      );
    }
    return null;
  };

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 20 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>

        <Row gutter={24}>
          <Col className="go-back-button">
            <button onClick={handleGoBackButton} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
        </Row>

        {planName === "Free Plan" ? (
          <div className="manage-container">
            <h1 className="subscription-title">Manage Subscription</h1>

            <div className="manage-subscription-page">
              <div className="subscription-section">
                <div className="subscription-section-header">YOUR PLAN</div>

                <div className="plan-detail">
                  <h2 className="plan-title">Free Subscription</h2>
                  <p className="plan-price">£0/7 days + free trial</p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>5 minutes Conversation Time</li>
                        <li>Single option for Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The monthly price is subject
                    to change.
                  </p>
                  <div className="action-buttons">{renderCancelButton()}</div>
                  { planName !== "Free Plan" &&  
                    (<Row className="pt-2" style={styles.formGroup}>
                    {subscriptionDetails?.status === "canceled" ? (
                      <Typography style={styles.labelStyle}>
                        Coupon can be applied once you subscribed!
                      </Typography>
                    ) :  
                    (<Typography
                        style={styles.labelStyle}
                        htmlFor="card-owner"
                      >
                        Apply Coupon To Get Discount!
                      </Typography>
                    )}
                
                    <Input
                      className="mt-2 input-field"
                      placeholder="Enter Coupon Code"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target.value)}
                      disabled={subscriptionDetails?.status === "canceled" }
                    /> 
                    </Row>)
                  }

                  { planName !== "Free Plan" && 
                    (<Button
                      className="button-color"
                      onClick={handleApplyCoupon}
                      loading={isCouponApplying}
                      disabled={subscriptionDetails?.status === "canceled" }
                    >
                      Apply Coupon
                    </Button> )
                  }

                </div>
              </div>

              <div className="subscription-section">
                <div className="subscription-section-header">
                  ALTERNATIVE OPTIONS
                </div>

                <div className="plan-detail">
                  <h2 className="plan-title">Monthly Subscription</h2>
                  <p className="plan-price">
                    £{monthlyPrice}/month + 30p transaction charge
                  </p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The monthly price is subject
                    to change.
                  </p>
                </div>

                <div className="plan-detail">
                  <h2 className="plan-title">Yearly Subscription</h2>
                  <p className="plan-price">£{annualPrice}/year</p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The price is subject to
                    change.
                  </p>
                  <div className="action-buttons">
                    <button
                      onClick={handleUpgradeClick}
                      className="upgrade-btn"
                    >
                      Update Subscription
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : planName === "Monthly Plan" ? (
          <div className="manage-container">
            <h1 className="subscription-title">Manage Subscription</h1>

            <div className="manage-subscription-page">
              <div className="subscription-section">
                <div className="subscription-section-header">YOUR PLAN</div>

                <div className="plan-detail">
                  <h2 className="plan-title">Monthly Subscription</h2>
                  <p className="plan-price">
                    £{monthlyPrice}/month + 30p transaction charge
                  </p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The monthly price is subject
                    to change.
                  </p>
                  <p>
                    Status:{" "}
                    {subscriptionDetails?.status.charAt(0).toUpperCase() +
                      subscriptionDetails?.status.slice(1)}
                  </p>
                  <div className="action-buttons">{renderCancelButton()}</div>

                  { planName !== "Free Plan" && 
                      (<Row className="pt-2" style={styles.formGroup}>
                        {subscriptionDetails?.status === "canceled" ? (
                          <Typography style={styles.labelStyle}>
                            Coupon can be applied once you subscribed!
                          </Typography>
                        ) :  
                        (
                          <Typography
                            style={styles.labelStyle}
                            htmlFor="card-owner"
                          >
                            Apply Coupon To Get Discount!
                          </Typography>
                        )}

                        <Input
                          className="mt-2 input-field"
                          placeholder="Enter Coupon Code"
                          value={coupon}
                          onChange={(e) => setCoupon(e.target.value)}
                          disabled={subscriptionDetails?.status === "canceled"}
                        />
                      </Row>) 
                  }

                  { planName !== "Free Plan" &&    
                      (<Button
                        className="button-color"
                        onClick={handleApplyCoupon}
                        loading={isCouponApplying}
                        disabled={subscriptionDetails?.status === "canceled"}
                      >
                        Apply Coupon
                      </Button>) 
                  }
                </div>
              </div>

              <div className="subscription-section">
                <div className="subscription-section-header">
                  ALTERNATIVE OPTIONS
                </div>

                {subscriptionDetails?.status === "canceled" && (
                  <div className="plan-detail">
                    <h2 className="plan-title">Monthly Subscription</h2>
                    <p className="plan-price">
                      £{monthlyPrice}/month + 30p transaction charge
                    </p>
                    <div className="plan-access-with-icon">
                      <p className="plan-access">
                        Access to:
                        <ul>
                          <li>Unlimited Conversation Time</li>
                          <li>Unlimited Additional Preferences and Links</li>
                        </ul>
                      </p>
                      <img
                        src={DownArrowIcon}
                        alt="Down Arrow"
                        className="down-arrow-icon"
                      />
                    </div>
                    <p className="plan-description">
                      Your subscription will automatically renew, but you can
                      cancel at any time. You must give one month’s notice
                      before your subscription is canceled. The monthly price is
                      subject to change.
                    </p>
                  </div>
                )}

                <div className="plan-detail">
                  <h2 className="plan-title">Yearly Subscription</h2>
                  <p className="plan-price">£{annualPrice}/year</p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The price is subject to
                    change.
                  </p>
                  <div className="action-buttons">
                    <button
                      onClick={handleUpgradeClick}
                      className="upgrade-btn"
                    >
                      Update Subscription
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="manage-container">
            <h1 className="subscription-title">Manage Subscription</h1>

            <div className="manage-subscription-page">
              <div className="subscription-section">
                <div className="subscription-section-header">YOUR PLAN</div>

                <div className="plan-detail">
                  <h2 className="plan-title">Yearly Subscription</h2>
                  <p className="plan-price">£{annualPrice}/year</p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The price is subject to
                    change.
                  </p>
                  <p>
                    Status:{" "}
                    {subscriptionDetails?.status.charAt(0).toUpperCase() +
                      subscriptionDetails?.status.slice(1)}
                  </p>

                  <div className="action-buttons">{renderCancelButton()}</div>

                  { planName !== "Free Plan" &&  
                    (<Row className="pt-2" style={styles.formGroup}>
                    {subscriptionDetails?.status === "canceled" ? (
                      <Typography style={styles.labelStyle}>
                        Coupon can be applied once you subscribed!
                      </Typography>
                    ) :  (
                      <Typography
                        style={styles.labelStyle}
                        htmlFor="card-owner"
                      >
                        Apply Coupon To Get Discount!
                      </Typography>
                    )}

                    <Input
                      className="mt-2 input-field"
                      placeholder="Enter Coupon Code"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target.value)}
                      disabled={subscriptionDetails?.status === "canceled"}
                    />
                  </Row>)}

                  { 
                    planName !== "Free Plan" && 
                   (
                    <Button
                        className="button-color"
                        onClick={handleApplyCoupon}
                        loading={isCouponApplying}
                        disabled={subscriptionDetails?.status === "canceled" }
                      >
                      Apply Coupon
                    </Button>
                    ) 
                  }
                </div>
              </div>

              <div className="subscription-section">
                <div className="subscription-section-header">
                  ALTERNATIVE OPTIONS
                </div>

                <div className="plan-detail">
                  <h2 className="plan-title">Monthly Subscription</h2>
                  <p className="plan-price">
                    £{monthlyPrice}/month + 30p transaction charge
                  </p>
                  <div className="plan-access-with-icon">
                    <p className="plan-access">
                      Access to:
                      <ul>
                        <li>Unlimited Conversation Time</li>
                        <li>Unlimited Additional Preferences and Links</li>
                      </ul>
                    </p>
                    <img
                      src={DownArrowIcon}
                      alt="Down Arrow"
                      className="down-arrow-icon"
                    />
                  </div>
                  <p className="plan-description">
                    Your subscription will automatically renew, but you can
                    cancel at any time. You must give one month’s notice before
                    your subscription is canceled. The monthly price is subject
                    to change.
                  </p>
                </div>

                {subscriptionDetails?.status === "canceled" && (
                  <div className="plan-detail">
                    <h2 className="plan-title">Yearly Subscription</h2>
                    <p className="plan-price">£{annualPrice}/year</p>
                    <div className="plan-access-with-icon">
                      <p className="plan-access">
                        Access to:
                        <ul>
                          <li>Unlimited Conversation Time</li>
                          <li>Unlimited Additional Preferences and Links</li>
                        </ul>
                      </p>
                      <img
                        src={DownArrowIcon}
                        alt="Down Arrow"
                        className="down-arrow-icon"
                      />
                    </div>
                    <p className="plan-description">
                      Your subscription will automatically renew, but you can
                      cancel at any time. You must give one month’s notice
                      before your subscription is canceled. The price is subject
                      to change.
                    </p>
                  </div>
                )}
                <div className="action-buttons">
                  <button onClick={handleUpgradeClick} className="upgrade-btn">
                    Update Subscription
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Col>
      {showCancelPopup && (
        <CancelPopup
          onClose={closeCancelPopup}
          onConfirm={confirmCancelSubscription}
        />
      )}
    </div>
  );
}

export default ManageSubscriptionPage;
